import React from 'react';
import PropTypes from 'prop-types';
import { InfoCircleIcon } from '../icons';
import './FeeInfoTooltip.css';

const FeeInfoTooltip = ({ text, label = 'More information', iconSrc = null }) => {
  if (!text) return null;

  return (
    <span className="fee-info-tooltip">
      <button
        type="button"
        className="fee-info-tooltip__trigger"
        aria-label={label}
        aria-describedby={undefined}
      >
        {iconSrc ? (
          <img src={iconSrc} alt="" className="fee-info-tooltip__icon" aria-hidden="true" />
        ) : (
          <InfoCircleIcon className="fee-info-tooltip__icon" aria-hidden="true" />
        )}
      </button>
      <span className="fee-info-tooltip__bubble" role="tooltip">
        {text}
      </span>
    </span>
  );
};

FeeInfoTooltip.propTypes = {
  text: PropTypes.string.isRequired,
  label: PropTypes.string,
  iconSrc: PropTypes.string
};

export default FeeInfoTooltip;
